import { useMemo } from 'react';

import { useAnalyticsContext } from '../BricksProvider';
import type { BricksObservability } from '../BricksProvider';

/**
 * This wrapper hook is added because not every FE app is onboarded to use observability, and observability
 * expects `globalObservability` to have been initialized when `trackJourneyEvent`. Thus, within the
 * scope of `bricks`, we catch any errors of the real `trackJourneyEvent call.
 * Additionally this hook allows us to use the client's version of observability for cases like when we need to use mobile's version of trackJourneyEvent
 * @returns functions trackJourneyEvent
 */
export const useObservabilitySafe = (): BricksObservability => {
  // This allows use to use the client's version of trackJourneyEvent
  const { useObservability } = useAnalyticsContext();
  const { trackJourneyEvent: actualTrackJourneyEvent } = useObservability();

  const trackJourneyEvent = useMemo<BricksObservability['trackJourneyEvent']>(
    () => (categoryName, eventName, eventData, options) => {
      try {
        actualTrackJourneyEvent(categoryName, eventName, eventData, options);
      } catch {}
    },
    [actualTrackJourneyEvent],
  );

  return useMemo(
    () => ({
      trackJourneyEvent,
    }),
    [trackJourneyEvent],
  );
};
